import styled, { keyframes } from 'styled-components'
import { giphyWhite, giphyBlack } from '@giphy/js-brand'

const edit = keyframes`
    0% { background-position: -36px -324px; }
    100% { background-position: -180px -324px; }
`
export const EditButton = styled.div<{ background?: string }>`
    border: 0;
    box-sizing: border-box;
    color: ${giphyWhite};
    cursor: pointer;
    font-family: interface;
    font-size: 14px;
    font-weight: bold;
    height: 36px;
    line-height: 36px;
    min-width: 36px;
    outline: none;
    text-align: center;
    user-select: none;
    -webkit-appearance: none;
    -webkit-font-smoothing: antialiased;
    background: ${(props) => (props.background ? props.background : `url('/static/img/svg/icon-animations.svg')`)}
        no-repeat;
    background-size: 180px 360px;
    padding: 0;
    width: 36px;
    background-color: rgba(${giphyBlack}, 0.9);
    display: inline-block;
    margin-right: 5px;
    vertical-align: top;
    position: relative;
    background-position: 0 -324px;
    /* float: right; */
    margin: 0;
    vertical-align: top;

    &:hover {
        color: ${giphyWhite};
        animation: ${edit} 0.4s steps(4) infinite;
    }

    &:active {
        opacity: 0.9;
    }

    &:disabled {
        cursor: default;
        opacity: 0.5;
    }
`
